export const PRIMARY_CONTACT_FIELDS = ["name", "telephone", "whatsapp", "email"];

export const PRIMARY_COMMUNICATION_PREFS = {
  get_email: "yes",
  get_whatsapp: "yes",
  get_billing: "yes",
  get_notification: "yes",
};

export function isPrimaryContactComplete(contact) {
  if (!contact) {
    return false;
  }
  return PRIMARY_CONTACT_FIELDS.every((field) => String(contact[field] || "").trim());
}

export function getPrimaryContactIncompleteMessage(contactName) {
  const label = String(contactName || "The selected contact").trim() || "The selected contact";
  return `${label} cannot be set as primary until name, telephone, WhatsApp, and email are all filled in. Please update that contact first.`;
}

export function getPrimaryContactRequiredFieldsMessage() {
  return "Primary contact must have name, telephone, WhatsApp, and email filled in.";
}

export function applyPrimaryCommunicationPrefs(contact) {
  return {
    ...contact,
    ...PRIMARY_COMMUNICATION_PREFS,
  };
}
